/**
 * Normaliza resposta de `GET /sale/recipient-selection-options` para VM do dropdown.
 * UI só conhece `{ value, label }` — nunca userId.
 *
 * @param {*} response
 * @returns {{ value: string, label: string }[]}
 */
export function toRecipientSelectionOptions(response) {
  const raw = Array.isArray(response)
    ? response
    : Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

  return raw
    .map((item) => {
      const value =
        typeof item?.value === "string" ? item.value.trim() : "";
      const label =
        typeof item?.label === "string"
          ? item.label.trim()
          : typeof item?.name === "string"
            ? item.name.trim()
            : "";

      if (!value || !label) return null;
      return { value, label };
    })
    .filter(Boolean);
}
